import React from 'react';
import { useQuery } from '@tanstack/react-query';
import { getProjectActivityList } from 'services/reactQueryservices';
import { projectActivityKey } from 'react_query/query-keys';

const useGetProjectActivityList = (
    page: number,
    row: number,
    search: string,
    division: string,
    district: string,
    upazila: string,
    projectType: string,
    subActivity: string,
    startDate: string,
    endDate: string
) => {
    const { data, isFetching, isFetched, isError, error } = useQuery({
        queryKey: [projectActivityKey, page, row, search, division, district, upazila, projectType, subActivity, startDate, endDate],
        queryFn: () => getProjectActivityList(page, row, search, division, district, upazila, projectType, subActivity, startDate, endDate),
        refetchOnWindowFocus: false
    })

    return {
        data, isFetching, isFetched, isError, error
    }
}

export default useGetProjectActivityList

